import { useEffect, useState } from "react";
import cl from "./Pump.module.css";
import gl from "../../../styles/Global.module.css";
import PumpSvg from "./PumpSvg";

import { useVariable } from "../../../hooks/useVariable";
import HandSvg from "./Hand.svg";

const Pump = ({st, fq}) => {
  const [isRotating, setIsRotating] = useState(true);

  const st_value = useVariable(st);
  const fq_value = useVariable(fq);

  const styles = [cl.pump_freq, gl.noselect];

  const handControled = st_value!=5 && st_value!=1;

  useEffect(() => {
    console.log('pump render');
    
    if (st_value == 1 || st_value == 2) {
      setIsRotating(true);
    } else {
      setIsRotating(false);
    }
  }, [st_value, fq_value]);

  return (
    <div className={cl.container}>
      { handControled ? (
      <div className={cl.iconContainer}>
        <HandSvg></HandSvg>
      </div>
    ) : (<div/>)
}
      <div className={`${cl.pump} ${gl.grow_on_hover}`}>
        {/* <button onClick={() => setIsRotating(!isRotating)}>{isRotating ? "Стоп" : "Старт"} */}
        {/* </button> */}
        <PumpSvg color={isRotating ? "#1366c5ff" : "#777777"} className={`${cl.pump_pic} ${isRotating ? cl.rotate : ""}`}/>
      <div className={styles.join(' ')}>{fq_value}</div>
      </div>
    </div>
  );
};

export default Pump;
